import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '@/api/client';
import { API_HOME_TASKS } from '@/api/endpoints';
import {
  DIARY_QUERY_KEY,
  HOME_TASKS_QUERY_KEY,
  HOME_TASK_QUERY_KEY,
} from '@/api/queryKeys';
import type {
  HomeTaskDetailsResponse,
  HomeTaskMessageThread,
  SendHomeTaskMessageRequest,
} from '@/types/diary';
import { unwrapAxiosResponse } from '@/utils/axios';

export const useSendHomeTaskMessage = (homeTaskId: number) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: SendHomeTaskMessageRequest) =>
      apiClient
        .post<HomeTaskMessageThread>(
          `${API_HOME_TASKS}/${homeTaskId}/messages`,
          payload,
        )
        .then(unwrapAxiosResponse),
    onSuccess: (messageThread) => {
      queryClient.setQueryData<HomeTaskDetailsResponse>(
        [...HOME_TASK_QUERY_KEY, homeTaskId],
        (previous) => previous && { ...previous, messageThread },
      );
      queryClient.invalidateQueries({ queryKey: HOME_TASKS_QUERY_KEY });
      queryClient.invalidateQueries({ queryKey: DIARY_QUERY_KEY });
    },
  });
};
